export class Anchor {
    static JumpTo(anchorId: any): void {
        let item = document.getElementById(anchorId);
        if (item !== null){
            window.scrollTo(0, item.offsetTop);    
        }
    }
}
